import { useLocalStorage } from './useLocalStorageState'
import { PREFERRED_EXPLORER_KEY } from '@components/settings/PreferredExplorerSettings'
import { CLUSTER_NAME } from '../utils/constants'
import { useCallback } from 'react'

export function usePreferredExplorerUrl(type: 'address' | 'transaction') {
  const [explorer] = useLocalStorage(PREFERRED_EXPLORER_KEY)

  return useCallback(
    (address: string) => {
      return `${explorer.url}${explorer[`${type}Param`]}${encodeURIComponent(
        address,
      )}${CLUSTER_NAME !== 'mainnet-beta' ? `?cluster=${CLUSTER_NAME}` : ''}`
    },
    [explorer, type],
  )
}
